import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizePreClaimsReason } from './normalize';

export const fetchPreClaimsReason = createProvider(api.fetchPreClaimsReason)
  .andThen((res) => normalizePreClaimsReason(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
